import { useEffect, useState } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";
import SoftAlert from "components/SoftAlert";

// Soft UI Dashboard PRO React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import ApiService from "services/ApiService";
import ToastUtils from "utils/ToastUtils";
import { useNavigate } from "react-router-dom";
import _ from "lodash";
import ValidationService from "services/ValidationService";
import Helpers from "utils/Helpers";
import SoftSelect from "components/SoftSelect";
import RoleSelect from "components/CustomFields/RolesSelect";
import YesNoSelect from "components/CustomFields/YesNoSelect";
import Input from "components/CustomFields/Input";

function UsersCreate() {
  const [showInfoAlert, setShowInfoAlert] = useState(false);
  const [alertInfoText, setAlertInfoText] = useState("");
  const [showPassAlert, setShowPassAlert] = useState(false);
  const [alertPassText, setAlertPassText] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");

  const [verifiedEmail, setVerifiedEmail] = useState(null);
  const [verifiedPhone, setVerifiedPhone] = useState(null);
  const [oldPassword, setOldPassword] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [roleId, setRoleId] = useState(0);

  const navigate = useNavigate();

  const handleVerifiedEmail = (val) => setVerifiedEmail(val === 1);
  const handleVerifiedPhone = (val) => setVerifiedPhone(val === 1);

  const createUser = async () => {
    setShowInfoAlert(false);
    const user = {
      firstName: firstName,
      lastName: lastName,
      email: email,
      phone: phone,
      password: password,
      confirmPassword: confirmPassword,
      disabled: false,
      emailVerified: verifiedEmail,
      phoneVerified: verifiedPhone,
      roleId: roleId,
    };

    const error = ValidationService.validateFullUser(user);

    if (error) {
      setAlertInfoText(error.message);
      setShowInfoAlert(true);
      return;
    }

    const response = await ApiService.postData(`/api/v1/users`, user);
    if (!response) {
      ToastUtils.error(`Αδυναμία επεξεργασίας χρήστη!`);
      return;
    }

    ToastUtils.success("Επιτυχία επεξεργασίας χρήστη!");
    navigate("/users/users-list");
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox mt={3} mb={4}>
        <Grid container spacing={3} justifyContent="center">
          <Grid item xs={12}>
            <Card sx={{ overflow: "visible" }}>
              <SoftBox p={2} lineHeight={1}>
                <SoftTypography variant="h6" fontWeight="medium">
                  Δημιουργία Χρήστη
                </SoftTypography>
                <SoftTypography variant="button" fontWeight="regular" color="text">
                  Συμπληρώστε τα στοιχεία του νέου χρήστη
                </SoftTypography>
                <Divider />
                {showInfoAlert && (
                  <SoftAlert color="error" dismissible show={showInfoAlert}>
                    {alertInfoText}
                  </SoftAlert>
                )}
                <Grid container spacing={3}>
                  <Input title="Όνομα" xs={12} md={6} handler={setFirstName} />
                  <Input title="Επώνυμο" xs={12} md={6} handler={setLastName} />
                </Grid>

                <Grid container spacing={3}>
                  <Input title="Email" xs={12} md={6} handler={setEmail} />
                  <Input title="Τηλέφωνο" xs={12} md={6} handler={setPhone} />
                </Grid>

                <Grid container spacing={3}>
                  <RoleSelect xs={12} md={4} handler={setRoleId} />
                  <YesNoSelect
                    title={"Επαληθευμένο Email?"}
                    xs={12}
                    md={4}
                    handler={handleVerifiedEmail}
                  />
                  <YesNoSelect
                    title={"Επαληθευμένο Τηλέφωνο?"}
                    xs={12}
                    md={4}
                    handler={handleVerifiedPhone}
                  />
                </Grid>

                <Grid container spacing={3}>
                  <Input title="Κωδικός" xs={12} md={6} handler={setPassword} type="password" />
                  <Input
                    title="Επαλήθευση Κωδικού"
                    xs={12}
                    md={6}
                    handler={setConfirmPassword}
                    type="password"
                  />
                </Grid>

                <SoftBox display="flex" justifyContent="flex-end" mt={3}>
                  <SoftButton
                    variant="gradient"
                    color="info"
                    style={{ width: "100%" }}
                    onClick={createUser}
                  >
                    ΔΗΜΙΟΥΡΓΙΑ
                  </SoftButton>
                </SoftBox>
              </SoftBox>
            </Card>
          </Grid>
        </Grid>
      </SoftBox>
      <Footer />
    </DashboardLayout>
  );
}

export default UsersCreate;
